import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export {
  DescriptionBody,
  EmptyHint,
  IconSlot,
  SectionBlock,
  SectionHeader,
  SectionTitle,
  TabRoot as OverviewRoot,
} from "../KgInspectorOntologyOverview/KgInspectorOntologyOverview.styles";

export const DetailValue = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const SharedWithList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;

export const SharedWithItem = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const ArtifactsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  padding: 0 ${spacing[3]} ${spacing[3]};
`;
